// extracted by mini-css-extract-plugin
module.exports = {"article":"blog-post-module--article--CBNcF"};